// Used in many components

// Angular
import { Injectable } from "@angular/core";

// Moment
import { DateString } from "@carnegie-learning/utility-types";
import moment from "moment";

// Services/Types/Helpers

@Injectable()
export class DateFormatterHelper {
    defaultDate: DateString = "";
    shortTime: DateString = "";

    constructor() {}

    formatDate(date: string | number | null) {
        if (date) {
            this.defaultDate = moment(date).format("MMM DD, YYYY");
            this.shortTime = moment(date).format("h:mm A");
            return `
                ${this.defaultDate}
                <br/>
                ${this.shortTime}
            `;
        } else {
            return `---`;
        }
    }

    formatDateOnly(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MMM DD, YYYY");
            return `
                ${this.defaultDate}
            `;
        } else {
            return `---`;
        }
    }

    formatDateOneLine(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MMM DD, YYYY");
            this.shortTime = moment(date).format("h:mm A");
            return `
                ${this.defaultDate} ${this.shortTime}
            `;
        } else {
            return `---`;
        }
    }

    formatDateOneLinePretty(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MMM DD, YYYY");
            this.shortTime = moment(date).format("h:mm A");
            return `
                ${this.defaultDate} at ${this.shortTime}
            `;
        } else {
            return `---`;
        }
    }

    formatShortDate(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("M/d/YYY");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }

    formatDateMMDDYYYY(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MM/DD/YYYY");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }

    formatDateMMDD(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MM/DD");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }

    formatShortTime(date: string | number) {
        if (date) {
            this.shortTime = moment(date).format("h:mm A");
            return this.shortTime;
        } else {
            return `---`;
        }
    }

    formatDateMMDDYY(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MM/DD/YY");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }

    formatDateMMDDYYHHMM(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MM/DD/YY h:mm A");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }

    formatDateMMDDHHMM(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MM/DD h:mm A");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }

    formatDateNoYear(date: string | number) {
        if (date) {
            this.defaultDate = moment(date).format("MMM DD");
            return this.defaultDate;
        } else {
            return `---`;
        }
    }
}
